import React, { useState } from 'react';
import ModuleHeader from '../common/ModuleHeader';
import { BookText, BookOpen, Scale, FileSpreadsheet, ListTree } from 'lucide-react';
import PlanComptable from './PlanComptable';
import JournalEcritures from './JournalEcritures';
import BalanceGenerale from './BalanceGenerale';
import GrandLivreView from './GrandLivreView';
import EtatsFinanciers from './EtatsFinanciers';

type TabType = 'plan' | 'ecritures' | 'balance' | 'grand_livre' | 'etats';

const ComptabiliteModule: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>('etats');

  const tabs = [
    { id: 'etats' as TabType, name: 'États financiers', icon: FileSpreadsheet },
    { id: 'balance' as TabType, name: 'Balance', icon: Scale },
    { id: 'grand_livre' as TabType, name: 'Grand livre', icon: BookOpen },
    { id: 'ecritures' as TabType, name: 'Journal / Écritures', icon: ListTree },
    { id: 'plan' as TabType, name: 'Plan comptable', icon: BookText },
  ];

  return (
    <div className="w-full space-y-5">
      <ModuleHeader
        title="Comptabilité"
        subtitle="Référentiel OHADA / SYSCOHADA"
        icon={FileSpreadsheet}
        tabs={tabs}
        active={activeTab}
        onChange={setActiveTab}
      />

      <div className="w-full">
        {activeTab === 'etats' && <EtatsFinanciers />}
        {activeTab === 'balance' && <BalanceGenerale />}
        {activeTab === 'grand_livre' && <GrandLivreView />}
        {activeTab === 'ecritures' && <JournalEcritures />}
        {activeTab === 'plan' && <PlanComptable />}
      </div>
    </div>
  );
};

export default ComptabiliteModule;
